import '.dg{font-size:1.125rem;}.ssr-plugin'
import '.f0{line-height:1.75rem;}.ssr-plugin'
import '.c9{text-decoration:none;}.ssr-plugin'
import '.f1{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="dg f0"
    >
      {translations.privacySubtitle}{' '}
      <a className="c9 f1"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c9 f1"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
